module.exports = __webpack_public_path__ + "static/media/RedLink.19d6144b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/RedLink.png
// module id = 362
// module chunks = 0